module.exports = __webpack_public_path__ + "img/17856_S.df71a87f.png";